import { useVerwaltungEinstellungen, useVerwaltungProtokoll } from '../hooks/data.js';

const ZEIT = new Intl.DateTimeFormat('de-CH', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
/** Vorher/nachher lesbar: ohne Eintrag in der Verwaltung gilt die Vorgabe (Standard, Paket oder Azure); Listen mit Komma. */
const wert = (v) => (v === null || v === undefined || v === '' ? '(Vorgabe)' : String(v).replace(/\s*[;\n|]\s*/g, ', '));

/** Wer hat wann was geändert (neueste zuerst). */
export function Protokoll() {
  const q = useVerwaltungProtokoll();
  const titel = Object.fromEntries((useVerwaltungEinstellungen().data?.einstellungen ?? []).map((e) => [e.name, e.titel]));
  if (q.isError && !q.data) return <div className="empty" role="alert">{q.error.message}<button className="btn" onClick={() => q.refetch()}>Erneut versuchen</button></div>;
  if (!q.data) return <div className="skeleton" style={{ height: 160 }} />;
  const eintraege = q.data.eintraege;
  if (!eintraege.length) return <div className="empty">Noch keine Änderungen.</div>;
  return (
    <section className="card list" style={{ padding: '4px 16px' }}>
      {eintraege.map((e, i) => (
        <div key={`${e.am}-${e.name}-${i}`} className="listrow" style={{ alignItems: 'flex-start' }}>
          <span className="stack" style={{ gap: 2, flex: 1, minWidth: 0 }}>
            <span style={{ fontWeight: 800 }}>{e.art === 'begriffe' ? `Begriff «${e.name}»` : titel[e.name] ?? e.name}</span>
            <span className="sub" style={{ fontSize: 13, overflowWrap: 'anywhere' }}>{wert(e.vorher)} → {wert(e.nachher)}</span>
            <span className="sub" style={{ fontSize: 12 }}>{ZEIT.format(new Date(e.am))} · {e.von}</span>
          </span>
        </div>
      ))}
    </section>
  );
}
